/**
 * ErrorCode is based on index number in AppError
 */
export enum ErrorCode {
    VEDLEGG_DOES_NOT_EXIST = 'FOR2440008',
    UNEXPECTED_VEDLEGG = 'FOR2440010',
    UPLOADING_VEDLEGG_FAILED = 'FOR2440011',
}
